import { style } from "@vanilla-extract/css";
import { cellStyles, columnStyles } from "plos/src/components/Table/tables.css";
import { borderedCell, vars } from "plos/src/styles";

export const statsWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});

export const statsElementCol = style([
  columnStyles,
  {
    position: "sticky",
    insetInlineStart: "0",
    backgroundColor: vars.colors.surface,
    width: 200,
    textAlign: "start",
  },
]);

export const statsElementCell = style([
  cellStyles,
  borderedCell,
  {
    position: "sticky",
    insetInlineStart: "0",
    backgroundColor: vars.colors.surface,
    padding: 0,
    textAlign: "start",
  },
]);

export const statsStatCol = style([
  columnStyles,
  {
    width: 50,
    textAlign: "center",
  },
]);

export const statsStatCell = style([
  cellStyles,
  {
    textAlign: "center",
  },
]);

export const statsTableWrapper = style({
  position: "relative",
  overflowX: "auto",
  textAlign: "center",
});
